import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Anchor, Clock, Zap, Repeat, CheckCircle } from 'lucide-react';
import { Button } from './ui/Button';
import { trackAddToCart } from '../utils/metaPixel';
export function MethodSection() {
  const goToIntermedio = () => {
    const element = document.getElementById('cta-intermedio');
    element?.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  };
  const scrollToPricing = () => {
    const element = document.getElementById('pricing-section');
    element?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const handlePurchaseClick = () => {
    trackAddToCart('Hábitos Atómicos Espirituales', 199, 'MXN');
    window.open('https://pay.hotmart.com/S104255087F?checkoutMode=10&bid=1770183530018', '_blank');
  };
  const steps = [{
    letter: 'A',
    title: 'Acción mínima',
    desc: '5 minutos (nunca cero). La meta no es intensidad, es presencia.',
    icon: <Clock className="w-6 h-6 text-[#d4af37]" data-id="element-157" />
  }, {
    letter: 'N',
    title: 'Nutriente espiritual',
    desc: 'Un ritual breve que conecta con Dios sin complicaciones.',
    icon: <Anchor className="w-6 h-6 text-[#d4af37]" data-id="element-158" />
  }, {
    letter: 'C',
    title: 'Cue (Señal)',
    desc: 'Algo físico y visible que dispara el hábito automáticamente.',
    icon: <Zap className="w-6 h-6 text-[#d4af37]" data-id="element-159" />
  }, {
    letter: 'L',
    title: 'Loop',
    desc: 'Repetición simple. Misma hora o mismo gatillo.',
    icon: <Repeat className="w-6 h-6 text-[#d4af37]" data-id="element-160" />
  }, {
    letter: 'A',
    title: 'Auditoría sin culpa',
    desc: 'Tracking para ver la verdad sin castigarte.',
    icon: <CheckCircle className="w-6 h-6 text-[#d4af37]" data-id="element-161" />
  }];
  return <section className="py-16 md:py-32 bg-[#0a1628] relative overflow-hidden" data-id="element-162">
      {/* Subtle background texture — hidden on mobile for performance */}
      <div className="absolute inset-0 opacity-5 hidden md:block" style={{
      backgroundImage: 'radial-gradient(#d4af37 1px, transparent 1px)',
      backgroundSize: '30px 30px'
    }} data-id="element-163"></div>

      <div className="max-w-5xl mx-auto px-5 md:px-6 relative z-10" data-id="element-164">
        <FadeIn data-id="element-165">
          <div className="text-center mb-12 md:mb-20" data-id="element-166">
            <span className="text-[#d4af37] tracking-widest uppercase text-xs md:text-sm font-semibold mb-3 md:mb-4 block" data-id="element-167">
              La Solución
            </span>
            <h2 className="text-3xl md:text-6xl text-white mb-4 md:mb-6" data-id="element-168">
              Presento: el Método <span className="text-[#d4af37]" data-id="element-169">ANCLA</span>
            </h2>
            <p className="text-base md:text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-170">
              Esto es lo que cambia todo. En vez de pelear por ser
              "disciplinado", tú construyes un ANCLA.
            </p>
          </div>
        </FadeIn>

        <div className="grid gap-4 md:gap-6" data-id="element-171">
          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.05} data-id="element-172">
              <div className="bg-[#1e3a5f]/20 border border-[#1e3a5f] p-5 md:p-8 rounded-lg flex items-start gap-4 md:gap-6" data-id="element-173">
                <div className="flex-shrink-0 w-12 h-12 md:w-16 md:h-16 bg-[#0a1628] rounded-full flex items-center justify-center border-2 border-[#1e3a5f] shadow-lg" data-id="element-174">
                  <span className="font-serif text-2xl md:text-3xl font-bold text-white" data-id="element-175">
                    {step.letter}
                  </span>
                </div>
                <div data-id="element-176">
                  <h3 className="text-lg md:text-2xl font-bold text-white mb-1 md:mb-2" data-id="element-177">
                    {step.title}
                  </h3>
                  <p className="text-gray-300 text-base md:text-lg leading-relaxed" data-id="element-178">
                    {step.desc}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.3} data-id="element-179">
          <div className="mt-10 md:mt-16 text-center" data-id="element-180">
            <p className="text-xl md:text-3xl font-serif italic text-[#f4e4c1] mb-8 md:mb-10" data-id="element-181">
              "Este no es un método para 'hacer más'.
              <br data-id="element-182" />
              Es un método para{' '}
              <span className="text-[#d4af37] underline decoration-1 underline-offset-4" data-id="element-183">
                dejar de desaparecer
              </span>
              ."
            </p>

            <div className="bg-[#1e3a5f]/20 border border-[#d4af37]/30 rounded-2xl p-6 md:p-8 max-w-md mx-auto" data-id="element-184">
              <p className="text-gray-300 text-sm md:text-base mb-4" data-id="element-185">
                ¿Ya sabes que esto es para ti?
              </p>
              <p className="text-gray-400 text-sm mb-4" data-id="element-186">
                Antes{' '}
                <span className="text-gray-500 line-through" data-id="element-187">$29.99 USD</span> —
                Ahora{' '}
                <span className="text-[#d4af37] font-bold text-xl" data-id="element-188">
                  $7.99 USD
                </span>{' '}
                — Solo por esta semana
              </p>
              <Button className="w-full" onClick={goToIntermedio} data-id="element-189">
                Quiero ver los planes + los 3 bonos
              </Button>
              <p className="text-gray-500 text-xs mt-3" data-id="element-190">
                Garantía de 7 días • Si no te sirve, te devolvemos tu dinero
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}